(function () {
  let imageViewerState = { sources: [], index: 0 };

  const showProductAddPending = (event) => {
    const productAddButton = event.target.closest('[data-rp-product-add]');
    if (!productAddButton || productAddButton.disabled) return;
    const bag = document.querySelector('[data-rp-bag]');
    const bagContent = document.querySelector('[data-rp-bag-content]');
    if (!bag || !bagContent) return;
    bag.hidden = false;
    document.body.classList.add('rp-overlay-open');
    bagContent.innerHTML = `
      <h2 class="rp-bag__title">Adding to bag</h2>
      <div class="rp-bag__empty">
        <p>One moment. Your item is being added for secure checkout.</p>
      </div>
    `;
  };

  document.addEventListener('click', showProductAddPending, true);

  const setImageViewerSource = (index) => {
    const viewer = document.querySelector('[data-rp-image-viewer]');
    const image = viewer ? viewer.querySelector('[data-rp-image-viewer-img]') : null;
    if (!viewer || !image || !imageViewerState.sources.length) return;
    imageViewerState.index = (index + imageViewerState.sources.length) % imageViewerState.sources.length;
    image.src = imageViewerState.sources[imageViewerState.index];
  };

  const closeImageViewer = () => {
    const viewer = document.querySelector('[data-rp-image-viewer]');
    const image = viewer ? viewer.querySelector('[data-rp-image-viewer-img]') : null;
    if (!viewer) return;
    viewer.hidden = true;
    if (image) image.removeAttribute('src');
    document.body.classList.remove('rp-overlay-open');
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rp-gallery-src]');
    if (trigger) {
      const viewer = document.querySelector('[data-rp-image-viewer]');
      const image = viewer ? viewer.querySelector('[data-rp-image-viewer-img]') : null;
      const source = trigger.getAttribute('data-rp-gallery-src');
      if (viewer && image && source) {
        event.preventDefault();
        imageViewerState.sources = Array.from(document.querySelectorAll('[data-rp-gallery-src]'))
          .map((item) => item.getAttribute('data-rp-gallery-src'))
          .filter(Boolean);
        imageViewerState.index = Math.max(0, imageViewerState.sources.indexOf(source));
        setImageViewerSource(imageViewerState.index);
        viewer.hidden = false;
        document.body.classList.add('rp-overlay-open');
      }
      return;
    }

    if (event.target.closest('[data-rp-image-viewer-prev]')) {
      event.preventDefault();
      setImageViewerSource(imageViewerState.index - 1);
      return;
    }

    if (event.target.closest('[data-rp-image-viewer-next]')) {
      event.preventDefault();
      setImageViewerSource(imageViewerState.index + 1);
      return;
    }

    if (event.target.closest('[data-rp-image-viewer-close]')) {
      closeImageViewer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeImageViewer();
    if (event.key === 'ArrowLeft') setImageViewerSource(imageViewerState.index - 1);
    if (event.key === 'ArrowRight') setImageViewerSource(imageViewerState.index + 1);
  });

  document.querySelectorAll('[data-rp-announcement]').forEach((announcement) => {
    const text = announcement.querySelector('[data-rp-announcement-text]');
    const prev = announcement.querySelector('[data-rp-announcement-prev]');
    const next = announcement.querySelector('[data-rp-announcement-next]');
    let messages = [];
    let index = 0;
    try {
      messages = JSON.parse(announcement.getAttribute('data-messages') || '[]').filter(Boolean);
    } catch (error) {
      messages = [];
    }
    const show = (direction) => {
      if (!text || !messages.length) return;
      index = (index + direction + messages.length) % messages.length;
      text.textContent = messages[index];
    };
    if (prev) prev.addEventListener('click', () => show(-1));
    if (next) next.addEventListener('click', () => show(1));
  });

  document.querySelectorAll('[data-rp-back]').forEach((button) => {
    button.addEventListener('click', () => {
      const fallback = button.getAttribute('data-rp-back-fallback') || '/collections/all';
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = fallback;
      }
    });
  });

  document.querySelectorAll('[data-rp-light-hero-toggle]').forEach((button) => {
    const frame = button.closest('.rp-light-hero__frame');
    const video = frame ? frame.querySelector('[data-rp-light-hero-video]') : null;
    if (!video) {
      button.hidden = true;
      return;
    }

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
        button.querySelector('span').textContent = 'Ⅱ';
        button.setAttribute('aria-label', 'Pause hero video');
      } else {
        video.pause();
        button.querySelector('span').textContent = '▶';
        button.setAttribute('aria-label', 'Play hero video');
      }
    });
  });

  const menuToggle = document.querySelector('[data-rp-menu-toggle]');
  const mobileMenu = document.querySelector('[data-rp-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('.rp-product-form').forEach((form) => {
    const variantsEl = document.querySelector('[data-rp-variants]');
    const idInput = form.querySelector('[data-rp-variant-id]');
    const priceEls = document.querySelectorAll('[data-rp-price]');
    let variants = [];

    try {
      variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    const formatMoney = (cents) => {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    };

    const getSelectedOptions = () => {
      return Array.from(form.querySelectorAll('.rp-option')).map((fieldset, index) => {
        const checked = fieldset.querySelector('input:checked');
        const label = form.querySelector(`[data-rp-option-label="${index}"]`);
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    };

    const applyVariant = (match) => {
      if (!match) return;
      idInput.value = match.id;
      priceEls.forEach((priceEl) => {
        priceEl.innerHTML = `<span>${formatMoney(match.price)}</span>${match.compare_at_price && match.compare_at_price > match.price ? `<s>${formatMoney(match.compare_at_price)}</s>` : ''}`;
      });
      form.querySelectorAll('[data-rp-variant-card]').forEach((button) => {
        button.classList.toggle('is-selected', Number(button.getAttribute('data-rp-variant-card')) === Number(match.id));
      });
      form.querySelectorAll('[type="submit"]').forEach((submit) => {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to bag' : 'Sold out';
      });
    };

    const updateVariant = () => {
      if (!variants.length) return;
      const selected = getSelectedOptions();
      const match = variants.find((variant) => {
        return selected.every((value, index) => variant.options[index] === value);
      });
      applyVariant(match);
    };

    form.querySelectorAll('.rp-option input').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    form.querySelectorAll('[data-rp-variant-card]').forEach((button) => {
      button.addEventListener('click', () => {
        const match = variants.find((variant) => Number(variant.id) === Number(button.getAttribute('data-rp-variant-card')));
        if (!match) return;
        match.options.forEach((value, index) => {
          const radio = form.querySelector(`.rp-option[data-rp-option-index="${index}"] input[value="${CSS.escape(value)}"]`);
          const label = form.querySelector(`[data-rp-option-label="${index}"]`);
          if (radio) radio.checked = true;
          if (label) label.textContent = value;
        });
        applyVariant(match);
      });
    });

    const qtyInput = form.querySelector('[data-rp-qty-input]');
    const minus = form.querySelector('[data-rp-qty-minus]');
    const plus = form.querySelector('[data-rp-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      });
      plus.addEventListener('click', () => {
        qtyInput.value = Number(qtyInput.value || 1) + 1;
      });
    }
  });

  const productTrack = document.querySelector('[data-rp-all-products-track]');
  const productData = window.homemellowProducts || [];
  if (productTrack && productData.length) {
    const money = (value) => value || '';
    productTrack.innerHTML = productData.map((product) => `
      <a class="rp-mini-product" href="${product.url}">
        <span class="rp-mini-product__image">
          ${product.image ? `<img src="${product.image}" loading="lazy" alt="${product.title.replace(/"/g, '&quot;')}">` : ''}
        </span>
        <span class="rp-mini-product__title">${product.title}</span>
        <span class="rp-mini-product__price">${money(product.price)}</span>
      </a>
    `).join('');
  }

  const scrollTrack = (selector, direction) => {
    const track = document.querySelector(selector);
    if (!track) return;
    track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.82, 760), behavior: 'smooth' });
  };

  const productPrev = document.querySelector('[data-rp-product-prev]');
  const productNext = document.querySelector('[data-rp-product-next]');
  if (productPrev) productPrev.addEventListener('click', () => scrollTrack('[data-rp-all-products-track]', -1));
  if (productNext) productNext.addEventListener('click', () => scrollTrack('[data-rp-all-products-track]', 1));

  const arrivalsPrev = document.querySelector('[data-rp-arrivals-prev]');
  const arrivalsNext = document.querySelector('[data-rp-arrivals-next]');
  if (arrivalsPrev) arrivalsPrev.addEventListener('click', () => scrollTrack('[data-rp-arrivals-track]', -1));
  if (arrivalsNext) arrivalsNext.addEventListener('click', () => scrollTrack('[data-rp-arrivals-track]', 1));

  const showcase = document.querySelector('[data-rp-puffy-showcase]');
  if (showcase) {
    const track = showcase.querySelector('[data-rp-showcase-track]');
    const prev = showcase.querySelector('[data-rp-showcase-prev]');
    const next = showcase.querySelector('[data-rp-showcase-next]');
    const nudge = (direction) => {
      if (!track) return;
      track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.9, 960), behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => nudge(-1));
    if (next) next.addEventListener('click', () => nudge(1));
  }

  const marqueeTrack = document.querySelector('[data-rp-marquee-track]');
  const newProductsTrack = document.querySelector('[data-rp-new-products-track]');
  const escapeMarqueeText = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));
  const marqueePrice = (product) => Number(product.price_num || String(product.price || '').replace(/[^0-9.]/g, '') || 0);
  const renderMarqueeCards = (products, modifier = '') => {
    const cards = products.map((product) => `
      <a class="rp-marquee-product" href="${product.url}">
        ${product.image ? `<img src="${product.image}" loading="lazy" decoding="async" fetchpriority="low" alt="${escapeMarqueeText(product.title)}">` : ''}
        <span>${escapeMarqueeText(product.title)}</span>
        <strong${modifier ? ` class="${modifier}"` : ''}>${escapeMarqueeText(product.price || '')}${product.compare ? ` <s>${escapeMarqueeText(product.compare)}</s>` : ''}</strong>
      </a>
    `).join('');
    return cards + cards;
  };
  const indexedProducts = (window.homemellowProducts || [])
    .filter((product) => Number(product.price_num || 0) >= 50)
    .sort((a, b) => marqueePrice(a) - marqueePrice(b))
    .slice(0, 18);
  if (marqueeTrack && indexedProducts.length) {
    marqueeTrack.innerHTML = renderMarqueeCards(indexedProducts);
  }

  const newGearProducts = [
    {
      title: 'Retractable Camping String Lights - 6-10 m Rechargeable Lantern | homemellow',
      url: '/products/homemellow-retractable-camping-string-light',
      image: 'https://cdn.shopify.com/s/files/1/0726/5379/9657/files/63fc773194af74bb0d6a36a712ae799b.jpg?v=1757940318',
      price: '$38.30',
      compare: '$39.90',
      price_num: 38.3
    },
    {
      title: 'Bug Zapper Indoor Outdoor - 365nm UV Mosquito Killer Lamp | homemellow',
      url: '/products/homemellow-uvtrap-mosquito-lamp',
      image: 'https://cdn.shopify.com/s/files/1/0726/5379/9657/files/5b59e4b5388f87a25c78bf8a7cdb6345.jpg?v=1757933863',
      price: '$39.90',
      price_num: 39.9
    },
    {
      title: 'Lawn & Garden Christmas Lights - Outdoor Rain-Snow Resistant Decor | homemellow',
      url: '/products/homemellow-christmas-outdoor-lawn-garden-rain-snow-resistant-solar-charging-decorative-lights',
      image: 'https://cdn.shopify.com/s/files/1/0726/5379/9657/files/3034a1133efe01daba919094b70c6310_1eebc75e-9bc5-4dfa-a4d0-a2b056135ab0.jpg?v=1762705424',
      price: '$45.52',
      compare: '$56.90',
      price_num: 45.52
    },
    {
      title: 'LED Holiday Decor - Colorful USB Lights for Christmas | homemellow',
      url: '/products/homemellow-led-holiday-decor-colorful-usb-lights-for-christmas',
      image: 'https://cdn.shopify.com/s/files/1/0726/5379/9657/files/3034a1133efe01daba919094b70c6310_45f8359b-23ec-4ac2-947e-0e15384faf95.jpg?v=1762705507',
      price: '$45.52',
      compare: '$56.90',
      price_num: 45.52
    },
    {
      title: 'R3 Inflatable Sleeping Pad - Lightweight Insulated Camping Mat | homemellow',
      url: '/products/r3-inflatable-sleeping-pad-lightweight-insulated-camping-mat-homemellow',
      image: 'https://cdn.shopify.com/s/files/1/0726/5379/9657/files/45789.jpg?v=1779101744',
      price: '$99.90',
      price_num: 99.9
    }
  ].sort((a, b) => marqueePrice(a) - marqueePrice(b));
  if (newProductsTrack) {
    newProductsTrack.innerHTML = renderMarqueeCards(newGearProducts, 'rp-marquee-product__price');
  }

  const quickModal = document.querySelector('[data-rp-quick-modal]');
  const quickContent = document.querySelector('[data-rp-quick-content]');
  const bag = document.querySelector('[data-rp-bag]');
  const bagContent = document.querySelector('[data-rp-bag-content]');
  const productCache = new Map();
  let quickState = { product: null, imageIndex: 0, variantId: null };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const recentKey = 'homemellow_recently_viewed';
  const readRecent = () => {
    try {
      return JSON.parse(localStorage.getItem(recentKey) || '[]').filter((item) => item && item.url && item.title);
    } catch (error) {
      return [];
    }
  };
  const writeRecent = (items) => {
    try {
      localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 8)));
    } catch (error) {}
  };
  const currentProductNode = document.querySelector('[data-rp-current-product]');
  let currentProduct = null;
  if (currentProductNode) {
    try {
      currentProduct = JSON.parse(currentProductNode.textContent || 'null');
    } catch (error) {
      currentProduct = null;
    }
    if (currentProduct && currentProduct.url) {
      const normalizedUrl = new URL(currentProduct.url, window.location.origin).pathname;
      const existing = readRecent().filter((item) => {
        const itemPath = new URL(item.url, window.location.origin).pathname;
        return itemPath !== normalizedUrl;
      });
      writeRecent([{ ...currentProduct, url: normalizedUrl }, ...existing]);
    }
  }
  const renderRecentlyViewed = () => {
    const currentPath = currentProduct ? new URL(currentProduct.url, window.location.origin).pathname : '';
    const items = readRecent().filter((item) => new URL(item.url, window.location.origin).pathname !== currentPath).slice(0, 6);
    if (!items.length || document.querySelector('[data-rp-recently-viewed]')) return;
    const section = document.createElement('section');
    section.className = 'rp-section rp-recently-viewed';
    section.setAttribute('data-rp-recently-viewed', '');
    section.innerHTML = `
      <div class="rp-recently-viewed__head">
        <div>
          <p>Recently viewed</p>
          <h2>Pick up where you left off.</h2>
        </div>
      </div>
      <div class="rp-recently-viewed__track">
        ${items.map((item) => `
          <a class="rp-recent-card" href="${escapeHtml(item.url)}">
            <span class="rp-recent-card__image">${item.image ? `<img src="${escapeHtml(item.image)}" loading="lazy" alt="${escapeHtml(item.title)}">` : ''}</span>
            <strong>${escapeHtml(item.title)}</strong>
            ${item.price ? `<span>${escapeHtml(item.price)}</span>` : ''}
          </a>
        `).join('')}
      </div>
    `;
    const productSection = document.querySelector('.rp-product');
    const homeHero = document.querySelector('.rp-light-hero');
    const anchor = productSection || homeHero || document.querySelector('main > .shopify-section:last-child') || document.querySelector('main');
    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement(productSection ? 'afterend' : 'afterend', section);
    }
  };
  renderRecentlyViewed();

  const stripHtml = (value) => {
    const node = document.createElement('div');
    node.innerHTML = value || '';
    return (node.textContent || node.innerText || '').replace(/\s+/g, ' ').trim();
  };

  const moneyFromCents = (cents) => {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  };

  const trackMetaEvent = (eventName, payload) => {
    if (typeof window.rpMetaPixelTrack === 'function') {
      window.rpMetaPixelTrack(eventName, payload || {});
    }
  };

  const getHandleFromUrl = (url) => {
    const parts = String(url || '').split('/products/');
    return parts[1] ? parts[1].split(/[?#/]/)[0] : '';
  };

  const getProduct = async (handle) => {
    if (!handle) throw new Error('Missing product handle');
    if (productCache.has(handle)) return productCache.get(handle);
    const response = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    productCache.set(handle, product);
    return product;
  };

  const firstAvailableVariant = (product) => {
    return (product.variants || []).find((variant) => variant.available) || (product.variants || [])[0] || null;
  };

  const reviewStats = {
    'homemellow-retractable-camping-string-light': { score: '4.72', count: '68 reviews' },
    'r3-inflatable-sleeping-pad-lightweight-insulated-camping-mat-homemellow': { score: '4.71', count: '34 reviews' },
    'homemellow-uvtrap-mosquito-lamp': { score: '4.85', count: '84 reviews' },
    'homemellow-led-holiday-decor-colorful-usb-lights-for-christmas': { score: '4.71', count: '35 reviews' },
    'homemellow-christmas-outdoor-lawn-garden-rain-snow-resistant-solar-charging-decorative-lights': { score: '4.66', count: '32 reviews' },
    'homemellow-high-output-usb-c-water-dispenser-pump': { score: '4.60', count: '323 reviews' },
    'homemellow-foldable-portable-water-dispenser-pump': { score: '4.80', count: 'Customer reviews' }
  };

  const quickTitles = {
    'homemellow-retractable-camping-string-light': 'Retractable Camping String Lights - 6-10 m Rechargeable Lantern',
    'r3-inflatable-sleeping-pad-lightweight-insulated-camping-mat-homemellow': 'R3 Inflatable Sleeping Pad - Lightweight Insulated Camping Mat',
    'homemellow-uvtrap-mosquito-lamp': 'UVTrap Mosquito Lamp',
    'homemellow-led-holiday-decor-colorful-usb-lights-for-christmas': 'LED Holiday Decor Colorful USB Lights',
    'homemellow-christmas-outdoor-lawn-garden-rain-snow-resistant-solar-charging-decorative-lights': 'Outdoor Solar Decorative Lights',
    'homemellow-high-output-usb-c-water-dispenser-pump': 'High-Output USB-C Water Dispenser Pump',
    'homemellow-foldable-portable-water-dispenser-pump': 'Foldable Portable Water Dispenser Pump'
  };

  const splitProductTitle = (title) => {
    const cleanTitle = String(title || '').split(' | ')[0];
    const parts = cleanTitle.split(' - ');
    return {
      family: parts[0] || cleanTitle || 'homemellow',
      style: parts.length > 1 ? parts.slice(1).join(' - ') : cleanTitle || 'homemellow'
    };
  };

  const openOverlay = (element) => {
    if (!element) return;
    element.hidden = false;
    document.body.classList.add('rp-overlay-open');
  };

  const closeOverlay = (element) => {
    if (!element) return;
    element.hidden = true;
    if ((!quickModal || quickModal.hidden) && (!bag || bag.hidden)) {
      document.body.classList.remove('rp-overlay-open');
    }
  };

  const selectedVariant = () => {
    if (!quickState.product) return null;
    return quickState.product.variants.find((variant) => Number(variant.id) === Number(quickState.variantId)) || firstAvailableVariant(quickState.product);
  };

  const renderQuickView = () => {
    if (!quickContent || !quickState.product) return;
    const product = quickState.product;
    const variant = selectedVariant();
    const images = product.images && product.images.length ? product.images : [product.featured_image].filter(Boolean);
    const imageUrl = images[quickState.imageIndex] || images[0] || '';
    const title = splitProductTitle(quickTitles[product.handle] || product.title);
    const stats = reviewStats[product.handle] || { score: '4.80', count: 'Customer reviews' };
    const copy = stripHtml(product.description).slice(0, 135) || 'Premium trail-ready comfort with a soft hand feel and dependable everyday performance.';
    const variants = product.variants || [];
    const sizeButtons = variants.map((item) => {
      const label = item.public_title && item.public_title !== 'Default Title'
        ? item.public_title
        : [item.option1, item.option2, item.option3].filter(Boolean).join(' / ') || 'One Size';
      const selected = Number(item.id) === Number(variant && variant.id);
      return `<button type="button" class="rp-quick__size${selected ? ' is-selected' : ''}" data-rp-qv-variant="${item.id}" ${item.available ? '' : 'disabled'}>${escapeHtml(label)}</button>`;
    }).join('');

    quickContent.innerHTML = `
      <div class="rp-quick__media">
        ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}">` : ''}
        ${images.length > 1 ? '<button type="button" class="rp-quick__arrow rp-quick__arrow--prev" data-rp-qv-prev aria-label="Previous image">‹</button><button type="button" class="rp-quick__arrow rp-quick__arrow--next" data-rp-qv-next aria-label="Next image">›</button>' : ''}
      </div>
      <div class="rp-quick__info">
        <p class="rp-quick__kicker">${escapeHtml(title.family)}</p>
        <h2 class="rp-quick__title">${escapeHtml(title.style)}</h2>
        <div class="rp-quick__rating">
          <span class="rp-quick__stars" aria-label="${escapeHtml(stats.score)} out of 5 stars">★★★★★</span>
          <span class="rp-quick__reviews">${escapeHtml(stats.score)} out of 5 · ${escapeHtml(stats.count)}</span>
        </div>
        <p class="rp-quick__copy">${escapeHtml(copy)}</p>
        <p class="rp-quick__price">
          ${variant ? `<span>${moneyFromCents(variant.price)}</span>` : ''}
          ${variant && variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${moneyFromCents(variant.compare_at_price)}</s>` : ''}
        </p>
        <p class="rp-quick__option-label">Size</p>
        <div class="rp-quick__sizes">${sizeButtons}</div>
        <div class="rp-quick__actions">
          <button type="button" class="rp-quick__btn rp-quick__btn--add" data-rp-qv-add data-variant-id="${variant ? variant.id : ''}">Add to Bag</button>
          <a class="rp-quick__btn rp-quick__btn--more" href="${escapeHtml(product.url || `/products/${product.handle}`)}">View More</a>
        </div>
      </div>
    `;
  };

  const openQuickView = async (handle) => {
    if (!quickModal || !quickContent) return;
    quickContent.innerHTML = '<div class="rp-quick__content"><p>Loading...</p></div>';
    openOverlay(quickModal);
    try {
      const product = await getProduct(handle);
      const variant = firstAvailableVariant(product);
      quickState = { product, imageIndex: 0, variantId: variant ? variant.id : null };
      renderQuickView();
    } catch (error) {
      quickContent.innerHTML = '<div class="rp-quick__content"><p>This product could not be loaded. Please open the product page instead.</p></div>';
    }
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach((link) => {
      if (/cart/i.test(link.textContent || '')) link.textContent = `Cart ${count}`;
    });
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };

  const changeCartLine = async (line, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('Could not update cart');
    return response.json();
  };

  const renderBag = (cart) => {
    if (!bagContent) return;
    updateCartCount(cart.item_count || 0);

    if (!cart.items || !cart.items.length) {
      bagContent.innerHTML = `
        <h2 class="rp-bag__title">Your Bag</h2>
        <div class="rp-bag__empty">
          <p>Your bag is empty.</p>
          <a class="rp-bag__checkout" href="/collections/all">Keep Shopping</a>
        </div>
      `;
      return;
    }

    const itemCards = cart.items.map((item, index) => `
      <div class="rp-bag__item">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : '<span></span>'}
        <div>
          <div class="rp-bag__item-head">
            <span class="rp-bag__item-title">${escapeHtml(item.product_title)}</span>
            <strong>${moneyFromCents(item.final_line_price || item.line_price)}</strong>
          </div>
          <p class="rp-bag__variant">${escapeHtml(item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Trail ready')}</p>
          <div class="rp-bag__qty-row">
            <span class="rp-bag__qty">
              <button type="button" data-rp-bag-qty="${index + 1}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-rp-bag-qty="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </span>
            <button type="button" class="rp-bag__remove" data-rp-bag-remove="${index + 1}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    const cartHandles = new Set(cart.items.map((item) => item.handle));
    const addOns = (window.homemellowProducts || [])
      .filter((product) => Number(product.price_num || 0) >= 50 && !cartHandles.has(getHandleFromUrl(product.url)))
      .slice(0, 6);

    const addOnCards = addOns.map((product) => `
      <div class="rp-bag__addon">
        <button type="button" data-rp-addon-handle="${escapeHtml(getHandleFromUrl(product.url))}" aria-label="Add ${escapeHtml(product.title)}">+</button>
        ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}">` : ''}
        <span class="rp-bag__addon-price">${escapeHtml(product.price || '')}</span>
        <span class="rp-bag__addon-title">${escapeHtml(product.title)}</span>
      </div>
    `).join('');

    bagContent.innerHTML = `
      <h2 class="rp-bag__title">Your Bag (${cart.item_count})</h2>
      <div class="rp-bag__free"><strong>Congratulations!</strong> You get free shipping</div>
      ${itemCards}
      <p class="rp-bag__addons-title">Add it on</p>
      <p class="rp-bag__addons-sub">homemellow favorites you'll love.</p>
      <div class="rp-bag__addons">${addOnCards}</div>
      <div class="rp-bag__footer">
        <div class="rp-bag__subtotal"><span>Subtotal</span><span>${moneyFromCents(cart.total_price)}</span></div>
        <label class="rp-bag__gift"><input type="checkbox"> Is this a gift?</label>
        <a class="rp-bag__checkout" href="/checkout">Checkout</a>
        <div class="rp-bag__trust" aria-label="Store promises">
          <span><i>30</i>Easy returns</span>
          <span><i>5★</i>Customer-loved</span>
          <span><i>3Y</i>Warranty</span>
        </div>
      </div>
    `;
  };

  const openBag = async () => {
    if (!bag || !bagContent) return;
    openOverlay(bag);
    bagContent.innerHTML = '<p>Loading bag...</p>';
    try {
      const cart = await getCart();
      renderBag(cart);
    } catch (error) {
      bagContent.innerHTML = '<p>Bag could not be loaded. Please try again.</p>';
    }
  };

  const addToBag = async (variantId, quantity = 1) => {
    if (!variantId) return;
    if (bag && bagContent) {
      openOverlay(bag);
      bagContent.innerHTML = `
        <h2 class="rp-bag__title">Adding to bag</h2>
        <div class="rp-bag__empty">
          <p>One moment. Your item is being added for secure checkout.</p>
        </div>
      `;
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
    });
    if (!response.ok) throw new Error('Could not add item');
    const item = await response.json();
    trackMetaEvent('AddToCart', {
      content_type: 'product',
      content_ids: [String(item.variant_id || variantId)],
      contents: [{
        id: String(item.variant_id || variantId),
        quantity: Number(quantity || item.quantity || 1)
      }],
      value: Number(item.final_price || item.price || 0) / 100,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
    if (bag && bagContent) {
      getCart()
        .then(renderBag)
        .catch(() => {
          bagContent.innerHTML = '<p>Item added. Open the cart to review checkout.</p><a class="rp-bag__checkout" href="/checkout">Checkout</a>';
        });
    } else {
      await openBag();
    }
  };

  document.querySelectorAll('form[action="/cart"], form[action$="/cart"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (event.submitter && event.submitter.name === 'checkout') {
        trackMetaEvent('InitiateCheckout', {
          content_type: 'product',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
      }
    });
  });

  document.querySelectorAll('.rp-template-cart button[name="checkout"]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      trackMetaEvent('InitiateCheckout', {
        content_type: 'product',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
      button.disabled = true;
      window.location.href = '/checkout';
    });
  });

  document.querySelectorAll('.rp-product-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || !submitter.matches('.rp-button[type="submit"]')) return;
      event.preventDefault();
      const originalText = submitter.textContent;
      submitter.textContent = 'Adding...';
      submitter.disabled = true;
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      if (bag && bagContent) {
        openOverlay(bag);
        bagContent.innerHTML = `
          <h2 class="rp-bag__title">Adding to bag</h2>
          <div class="rp-bag__empty">
            <p>One moment. Your item is being added for secure checkout.</p>
          </div>
        `;
      }
      window.setTimeout(() => {
        addToBag(variantId, quantity)
          .then(() => {
            submitter.textContent = 'Added';
          })
          .catch(() => {
            submitter.textContent = 'Try again';
          })
          .finally(() => {
            window.setTimeout(() => {
              submitter.disabled = false;
              submitter.textContent = originalText;
            }, 1200);
          });
      }, 50);
    });
  });

  document.addEventListener('click', async (event) => {
    if (event.target.closest('a[href="/checkout"], a[href$="/checkout"], button[name="checkout"]')) {
      trackMetaEvent('InitiateCheckout', {
        content_type: 'product',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    const productAddButton = event.target.closest('[data-rp-product-add]');
    if (productAddButton) {
      event.preventDefault();
      const form = productAddButton.closest('.rp-product-form');
      if (!form) return;
      const originalText = productAddButton.textContent;
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      productAddButton.textContent = 'Adding...';
      productAddButton.disabled = true;
      if (bag && bagContent) {
        openOverlay(bag);
        bagContent.innerHTML = `
          <h2 class="rp-bag__title">Adding to bag</h2>
          <div class="rp-bag__empty">
            <p>One moment. Your item is being added for secure checkout.</p>
          </div>
        `;
      }
      window.setTimeout(() => {
        addToBag(variantId, quantity)
          .then(() => {
            productAddButton.textContent = 'Added';
          })
          .catch(() => {
            productAddButton.textContent = 'Try again';
          })
          .finally(() => {
            window.setTimeout(() => {
              productAddButton.disabled = false;
              productAddButton.textContent = originalText;
            }, 1200);
          });
      }, 50);
      return;
    }

    const quickButton = event.target.closest('[data-rp-quick-view]');
    if (quickButton) {
      event.preventDefault();
      openQuickView(quickButton.getAttribute('data-handle'));
      return;
    }

    const addButton = event.target.closest('[data-rp-add-to-bag]');
    if (addButton) {
      event.preventDefault();
      addButton.disabled = true;
      try {
        await addToBag(addButton.getAttribute('data-variant-id'), 1);
      } catch (error) {
        addButton.textContent = 'Try Again';
      } finally {
        addButton.disabled = false;
      }
      return;
    }

    if (event.target.closest('[data-rp-close-quick]')) {
      closeOverlay(quickModal);
      return;
    }

    if (event.target.closest('[data-rp-close-bag]')) {
      closeOverlay(bag);
      return;
    }

    const variantButton = event.target.closest('[data-rp-qv-variant]');
    if (variantButton) {
      quickState.variantId = variantButton.getAttribute('data-rp-qv-variant');
      renderQuickView();
      return;
    }

    if (event.target.closest('[data-rp-qv-prev]') || event.target.closest('[data-rp-qv-next]')) {
      const images = quickState.product && quickState.product.images ? quickState.product.images : [];
      if (!images.length) return;
      const step = event.target.closest('[data-rp-qv-prev]') ? -1 : 1;
      quickState.imageIndex = (quickState.imageIndex + step + images.length) % images.length;
      renderQuickView();
      return;
    }

    const quickAdd = event.target.closest('[data-rp-qv-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      try {
        await addToBag(quickAdd.getAttribute('data-variant-id'), 1);
        closeOverlay(quickModal);
      } catch (error) {
        quickAdd.textContent = 'Try Again';
      } finally {
        quickAdd.disabled = false;
      }
      return;
    }

    const qtyButton = event.target.closest('[data-rp-bag-qty]');
    if (qtyButton) {
      try {
        const cart = await changeCartLine(Number(qtyButton.getAttribute('data-rp-bag-qty')), Number(qtyButton.getAttribute('data-qty')));
        renderBag(cart);
      } catch (error) {}
      return;
    }

    const removeButton = event.target.closest('[data-rp-bag-remove]');
    if (removeButton) {
      try {
        const cart = await changeCartLine(Number(removeButton.getAttribute('data-rp-bag-remove')), 0);
        renderBag(cart);
      } catch (error) {}
      return;
    }

    const addonButton = event.target.closest('[data-rp-addon-handle]');
    if (addonButton) {
      addonButton.disabled = true;
      try {
        const product = await getProduct(addonButton.getAttribute('data-rp-addon-handle'));
        const variant = firstAvailableVariant(product);
        if (variant) await addToBag(variant.id, 1);
      } catch (error) {
        addonButton.textContent = '!';
      } finally {
        addonButton.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOverlay(quickModal);
      closeOverlay(bag);
    }
  });
})();
